module.exports = __webpack_public_path__ + "static/media/hige_priority.f6ae012d.svg";